module.exports = __webpack_public_path__ + "fonts/SageHeadline-Black.b74d2555.ttf";